<ng-container *ngIf="!hiddenHtml">
  <button kendoButton
          [primary]="true"
          (click)="signout()">
    Se déconnecter
  </button>
</ng-container>
